// store/modules/student.js

export default {
  namespaced: true,

  state: {
    studentToken: null,
    email: null,
    studentId:null,
    semesterId: null,
    department: null,
  },
  getters: {
     studentdata: (state) => state,
  },

  mutations: {
    SET_STUDENT_DATA(state, payload) {
      state.studentToken = payload.token
      state.email = payload.email
      state.studentId = payload.studentId
      state.semesterId = payload.semesterId
      state.department = payload.department
    },

    CLEAR_STUDENT_DATA(state) {
      state.studentToken = null
      state.email = null
      state.studentId = null
      state.semesterId = null
      state.department = null
    }
  },

  actions: {
    saveStudentData({ commit }, payload) {
      commit("SET_STUDENT_DATA", payload)
    },

    clearStudentData({ commit }) {
      commit("CLEAR_STUDENT_DATA")
    }
  }
}